(() => {
  if (window.yhsHealthcareV11) return;
  window.yhsHealthcareV11 = true;
  const init = (root = document) => {
    root.querySelectorAll('.hc11').forEach(section => {
      if (section.dataset.hcReady) return;
      section.dataset.hcReady = 'true';
      const focus = index => {
        section.querySelectorAll('[data-hc-focus]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.hcFocus) === index)));
        section.querySelectorAll('[data-hc-note]').forEach(note => note.classList.toggle('hc11-note--focused', Number(note.dataset.hcNote) === index));
        section.querySelectorAll('.hc11-pin').forEach((pin, i) => pin.classList.toggle('hc11-pin--focused', i === index));
      };
      section.querySelectorAll('[data-hc-focus]').forEach(button => button.addEventListener('click', () => focus(Number(button.dataset.hcFocus))));
      if (section.querySelector('[data-hc-focus]')) focus(0);
      const preview = new URLSearchParams(location.search).get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? window.Shopify.theme.id : null);
      if (preview) section.querySelectorAll('a[href^="/"], .hc11-pagination a').forEach(link => {
        const url = new URL(link.href, location.origin);
        if (url.origin === location.origin) { url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.querySelector('.hc11, .hc11-inquiry')) {
    const observed = new WeakSet();
    const place = () => document.body.style.setProperty('--hc-widget-offset', `${Math.max(0, Math.round(document.body.getBoundingClientRect().bottom - innerHeight))}px`);
    addEventListener('scroll', place, { passive: true });
    addEventListener('resize', place);
    new ResizeObserver(place).observe(document.body);
    place();
    const refresh = () => {
      const chat = document.querySelector('shopify-chat')?.shadowRoot;
      const runtime = chat?.querySelector('shopify-agent-runtime');
      const runtimeRoot = runtime?.shadowRoot;
      const tidio = document.querySelector('#tidio-chat')?.shadowRoot;
      const launcher = runtimeRoot?.querySelector('[part~="activator"], button[aria-label="Chat"]') || chat?.querySelector('[part~="activator"], button[aria-label="Chat"]');
      const shopifyReady = Boolean(launcher);
      const button = tidio?.querySelector('#button');
      const tidioReady = Boolean(tidio?.querySelector('#button-body'));
      const shopifyOpen = Boolean(shopifyReady && (launcher.getAttribute('aria-expanded') === 'true' || runtime?.hasAttribute('open')));
      const shopifyUnavailable = Boolean(runtimeRoot?.querySelector('.panel__unavailable:not([hidden])'));
      const tidioPrimary = tidioReady && (!shopifyOpen || shopifyUnavailable);
      const open = tidioPrimary
        ? Boolean(button?.classList.contains('chat-open'))
        : shopifyOpen;
      document.body.toggleAttribute('data-hc-shopify-ready', shopifyReady);
      document.body.toggleAttribute('data-hc-tidio-primary', tidioPrimary);
      document.body.toggleAttribute('data-hc-chat-open', open);
      [chat, runtimeRoot, tidio].filter(Boolean).forEach(root => {
        if (observed.has(root)) return;
        observed.add(root);
        new MutationObserver(refresh).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded', 'class', 'open'] });
      });
      return tidioReady;
    };
    new MutationObserver(refresh).observe(document.body, { subtree: true, childList: true });
    let attempts = 0;
    const connect = () => { const ready = refresh(); if (++attempts < 60 && !ready) setTimeout(connect, 500); };
    connect();
  }
})();
